import { FormControl, FormGroup } from '@angular/forms';

import { Media } from '@eiq/files/models';

import { IMediaForm } from './media-form.interface';

export class MediaForm {
  form = new FormGroup<IMediaForm>({
    mediaId: new FormControl<string>(''),
    name: new FormControl<string>(''),
    type: new FormControl<string>(''),
    url: new FormControl<string>('')
  });

  constructor(media: Media = null) {
    if (media) {
      this.form.patchValue(media);
    }
  }
}
